import WebComponent from '../base/WebComponent';

class EvalNumberQuestion extends WebComponent {
    id = "";
    guid = "";
    text = "";
    required = false;
    value = "";

    beforeMount() {
        return new Promise((resolve, reject) => {
            if (this.props.question != null) {
                const { id, guid, text, optional, error } = this.props.question;
                this.id = id;
                this.guid = guid;
                this.text = text;
                this.required = !optional;
                this.value = this.props.value || '';
                this.errorMessage = error ? error.message : null;
            }

            resolve(true);
        })
    }

    template() {
        return `
            <fieldset class="fu-fieldset">
                <legend class="fu-legend">${this.text}${this.required ? '*' : ''}</legend>
                <input 
                    class="fu-input number" 
                    type="number" 
                    value="${this.value}"
                    ${this.required ? 'required' : ''}
                    id="${this.guid}" 
                    name="${this.guid}"
                    placeholder="Skriv et tal"
                >
                ${this.errorMessage ? `
                    <span class="fu-fieldset-error">* ${this.errorMessage}</span>
                ` : ''}
            </fieldset>
        `;
    }
}

customElements.define( 'eval-number-question', EvalNumberQuestion );